import { Router } from '@angular/router';
import { UserService } from '../services';
import { UserRole } from '@ml/core/types/enums';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "../services/user.service";
var CustomerGuard = /** @class */ (function () {
    function CustomerGuard(router, userService) {
        this.router = router;
        this.userService = userService;
    }
    CustomerGuard.prototype.canActivate = function (next, state) {
        var user = this.userService.user;
        if (user.role === UserRole.CUSTOMER) {
            return true;
        }
        this.router.navigate(['/']);
        return false;
    };
    CustomerGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CustomerGuard_Factory() { return new CustomerGuard(i0.ɵɵinject(i1.Router), i0.ɵɵinject(i2.UserService)); }, token: CustomerGuard, providedIn: "root" });
    return CustomerGuard;
}());
export { CustomerGuard };
